import { FC } from 'react'

const WarningIcon: FC<React.SVGProps<SVGSVGElement>> = ({ ...rest }) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.1667 15.1667C15.1667 15.8107 14.644 16.3333 14 16.3333C13.356 16.3333 12.8334 15.8107 12.8334 15.1667V10.5C12.8334 9.85601 13.356 9.33334 14 9.33334C14.644 9.33334 15.1667 9.85601 15.1667 10.5V15.1667ZM14 19.8333C13.356 19.8333 12.8334 19.3107 12.8334 18.6667C12.8334 18.0227 13.356 17.5 14 17.5C14.644 17.5 15.1667 18.0227 15.1667 18.6667C15.1667 19.3107 14.644 19.8333 14 19.8333ZM26.3212 19.0202L17.3705 4.18134C16.6717 3.02401 15.4117 2.33334 14 2.33334C12.5884 2.33334 11.3284 3.02401 10.6295 4.18134L1.67886 19.0202C1.01619 20.1203 0.99636 21.4433 1.62636 22.5587C2.30186 23.7568 3.61436 24.5 5.04936 24.5H22.9507C24.3857 24.5 25.6982 23.7568 26.3737 22.5587C27.0037 21.4433 26.9839 20.1203 26.3212 19.0202Z'
        fill='#E49A43'
      />
    </svg>
  )
}

export default WarningIcon
